export default __webpack_public_path__ + "static/mi-bg-af432e4e7e59fb2f3abd4f9322ae0a3e.png";